import cn from 'classnames'
import React, { FC, useState, useEffect, useRef, useMemo, SyntheticEvent } from 'react'
import { ITooltip } from 'types/Form'
import s from './Tooltip.module.css'
import Image from 'next/image'

const Tooltip = ({ text, type = "defualt", className, classNameText, inactiveImage, activeImage }: ITooltip) => {
    return <div className={cn(s.root, {[s.small] : type == "small"}, className)} >
        <div
            className={cn(s.inactive)}
        >
            <Image
                src={inactiveImage && inactiveImage != "" ? inactiveImage : "/assets/onboarding/tooltip/inactive.png"}
                width="20"
                height="20"
                layout="intrinsic"
            />
        </div>
        <div
            className={cn(s.active)}
        >
            <Image
                src={activeImage && activeImage != "" ? activeImage : "/assets/onboarding/tooltip/active.png"}
                width="20"
                height="20"
                layout="intrinsic"
            />
            <div className={cn(s.text, classNameText)}>
                {text}
            </div>
        </div>
    </div>
}
export default Tooltip